import { Default_Site_Source } from '@treadinc/horizon-api-spec';
import { Dayjs } from 'dayjs';

import { AddressItem } from '~hooks/useAddress/models/AddressItem';
import { CompanyShareBasic } from '~hooks/useCompanyShares/models';
import { Geofence, SiteBasic } from '~hooks/useSites/models';

export interface Form {
  dropOffAddress: SiteBasic | null;
  dropOffLatLng: string;
  pickUpAddress: SiteBasic | null;
  pickUpLatLng: string;
  stagingAddress: SiteBasic | null;
  stagingLatLng: string;
}

export interface AddressOption {
  address?: AddressItem;
  companyShare?: CompanyShareBasic | null;
  discardedAt: Dayjs | null;
  externalId?: string;
  geofence?: Geofence | null;
  id: string;
  lat: number | string;
  lng: number | string;
  moving_site?: { equipment_id: string };
  name: string;
  placeId?: string;
  siteId: string | null;
  // Parent entities (Order / Project) that contribute this default site. Only
  // populated for rows from the merged /default_sites endpoints; drives the
  // targeted DELETE calls when a default site is removed.
  sources?: Default_Site_Source[];
  type: AddressType;
}

export interface AddressOptionForNewSite {
  address: AddressItem;
  geofence?: Geofence;
  lat: number;
  latLon: string;
  lng: number;
  moving_site?: { equipment_id: string };
  name?: string;
  placeId?: string;
}

export enum AddressType {
  Suggestions = 'Suggestions',
  Sites = 'Sites',
  DefaultSites = 'Default Sites',
}
